import React from "react";

/**
 * Reusable smartphone mockup. Children compose the on-screen content.
 * Variants: "dashboard" | "invoice" | "clients" — provided as children.
 */
export const PhoneMockup = ({ children, className = "", floating = false, testid = "phone-mockup" }) => {
  return (
    <div
      data-testid={testid}
      className={`relative mx-auto w-[260px] h-[540px] md:w-[300px] md:h-[620px] ${floating ? "animate-float" : ""} ${className}`}
    >
      {/* Outer device */}
      <div className="absolute inset-0 rounded-[2.6rem] bg-gradient-to-b from-slate-800 to-slate-950 p-[3px] shadow-[0_30px_80px_-20px_rgba(59,130,246,0.35)]">
        <div className="relative h-full w-full rounded-[2.4rem] bg-[#060B14] overflow-hidden border border-white/5">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 z-30 h-6 w-28 bg-black rounded-b-2xl flex items-end justify-center pb-1">
            <div className="h-1.5 w-1.5 rounded-full bg-slate-700 mx-1" />
            <div className="h-1.5 w-10 rounded-full bg-slate-800" />
          </div>
          {/* Status bar */}
          <div className="absolute top-2 inset-x-0 px-6 pt-1 flex items-center justify-between text-[9px] text-slate-300 z-20 font-medium">
            <span>9:41</span>
            <span className="flex items-center gap-1">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" />
              5G
            </span>
          </div>
          {/* Screen content */}
          <div className="absolute inset-0 pt-9 pb-2 px-3 overflow-hidden">
            {children}
          </div>
        </div>
      </div>
      {/* Side buttons */}
      <div className="absolute -left-[3px] top-24 h-12 w-[3px] rounded-l-md bg-slate-700" />
      <div className="absolute -left-[3px] top-40 h-16 w-[3px] rounded-l-md bg-slate-700" />
      <div className="absolute -right-[3px] top-32 h-20 w-[3px] rounded-r-md bg-slate-700" />
    </div>
  );
};

export default PhoneMockup;
